import styles from "./InputClear.module.css";

function InputClear({ onClick, type = "text", ...props }) {
  return (
    <div className={styles.container_input_clear}>
      <input type={type} className={styles.input_style} {...props} />
      {props.value.length | props.value ? (
        <span onClick={onClick}>X</span>
      ) : null}
    </div>
  );
}

export default InputClear;